function init() {
    // eslint-disable-next-line no-unused-vars
    let windowWidth = window.innerWidth;
    showDiamons();
    window.addEventListener("resize", () => {
        windowWidth = window.innerWidth;
        showDiamons();
    });
}

export default { init };

function showDiamons() {
    let windowWidth = window.innerWidth;
    const wrapperMobile = document.querySelector(".wrapper-mobile");
    const wrapperDesktop = document.querySelector(".wrapper-desktop");

    if (wrapperMobile && wrapperDesktop) {
        if (windowWidth < 768) {
            wrapperDesktop.style.display = "none";
            wrapperMobile.style.display = "flex";
        } else {
            wrapperDesktop.style.display = "flex";
            wrapperMobile.style.display = "none";
        }
    }
}
